/**
 * Sweep Control (R27) — react-query hooks.
 *
 * Health has no global/background polling: it fetches on mount and is stale
 * only when a caller explicitly refetches. SweepControl temporarily refetches
 * this same authorized health read after a manual dispatch, then stops as soon
 * as that exact run records finishedAt.
 */

import { useMutation, useQuery } from "@tanstack/react-query";
import { fetchSweepHealth, triggerManualSweep } from "./api";
import type { RawSweepHealth, RawTriggerResult } from "./types";

export function useSweepHealth() {
  return useQuery<RawSweepHealth>({
    queryKey: ["sweep-control", "health"],
    queryFn: () => fetchSweepHealth(),
    staleTime: Infinity,
    retry: false,
  });
}

export function useTriggerSweep() {
  return useMutation<RawTriggerResult, Error, void>({
    mutationFn: () => triggerManualSweep(),
    retry: false,
  });
}
